// Dependencies
import React, {useState} from 'react'
import {connect} from 'react-redux'

// Actions
import {storePayload} from '../actions/storePayload'
import {enterMFA} from '../actions/enterMFA'

// Components
import {Input, Button} from '@lazarusai/forms-ui-components'

// Styles
import '../index.css'
import '../styles/MFA.css'

function MFA(props) {
  const [MFACode, setMFACode] = useState('')
  function onSubmitMFA(e) {
    e.preventDefault()
    setMFACode('')
    props.storePayload({isLoading: true})
    props.enterMFA(MFACode, props.mfaError)
  }
  return (
    <main>
      <form onSubmit={onSubmitMFA}>
        <p className={`${'white-text'}`}>
          Please check your two-factor authentication app
          and enter the one-time password in the field below:
        </p>
        <Input
          label='Security Code'
          key='mfa-code-field'
          name='mfaCode'
          id='mfaCode'
          onChange={(e) => setMFACode(e.target.value)}
          value={MFACode}
          autoComplete='off'
          theme={props.theme}
        />
        <footer className={`${'mfa-footer'}`}>
          <Button
            type={1}
            onClick={onSubmitMFA}
            text='Enter Code'
            theme={props.theme}
          />
          <Button
            type={10}
            text='Cancel'
            onClick={() => {
              props.storePayload({onMFATab: false})
              setMFACode('')
            }}
            theme={props.theme}
          />
        </footer>
      </form>
    </main>
  )
}

const mapStateToProps = (state) => ({
  theme: state.userReducer.theme,
  mfaError: state.userReducer.mfaError, // MFA related
})

export default connect(
    mapStateToProps,
    {storePayload, enterMFA},
)(MFA)
